<template>
    <div class="menu-margin absolute-container-index">
        <h1 v-if="uploading === 'in progress'">{{ $t('registrationUploadSubmit') }}</h1>
        <h1 v-if="uploading === 'done'" style="padding-bottom: 0px;">{{ $t('registrationUploadSubmitted') }}</h1>
        <p v-if="uploading === 'done'" style="padding-bottom: 20px;">{{ $t('registrationUploadSubmittedTextUnder') }}</p>
        <h1 v-if="uploading === 'error'">{{ $t('registrationUploadError') }}</h1>
        <div class="circle-loader" :class="{'load-complete': uploading === 'done', 'load-error': uploading === 'error'}">
            <div class="checkmark draw" :class="{'display-none': uploading === 'in progress' || uploading === 'error'}"></div>
            <div class="cross draw" :class="{'display-block': uploading === 'error'}"></div>
        </div>
        <div v-if="form.receiptText && uploading === 'done'" class="content">
            <p class="text-center">{{form.receiptText}}</p>
        </div>
        <div class="button-menu">
            <a class="button success-outlined" v-if="uploading === 'done' && form.limitToSingleRegistration !== undefined && form.limitToSingleRegistration === false" @click="newRegistration()">{{ $t('createNewRegistration')}}</a>
            <a class="button primary" v-if="uploading === 'error'" @click="tryAgain()">{{ $t('tryAgain') }}</a>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import clearQueue from "./../js/clearQueue";

export default {
  name: "Kvittering",
  data() {
    return {
      uploading: null
    };
  },
  computed: {
    ...mapGetters({
      form: "getActiveForm",
      vuexImages: "getImages",
      repeaterImages: "getRepeaterImages"
    })
  },
  methods: {
    ...mapActions({
      submitFormToServer: "submitFormToServer",
      setDefaultComponentActive: "setDefaultComponentActive",
      sendErrorLog: "setErrorLog",
      setupRegistrationData: "setupRegistrationData"
    }),
    newRegistration() {
      this.setupRegistrationData({
        formId: localStorage.getItem("formId"),
        apiKey: localStorage.getItem("apiKey"),
        revisionNo: localStorage.getItem("revisionNo")
      });
      return new Promise(resolve => {
        resolve(this.setDefaultComponentActive());
      }).then(() => {
        this.$nextTick(() => {
          console.log("router ..:", this);
          // window.location.href = window["APIhost"] + "?formId=" + localStorage.getItem("formId") + "&apiKey="
          this.$router.push({
            name: "Registration"
          });
        });
      });
    },
    tryAgain() {
      this.uploadRegistration();
    },
    uploadRegistration() {
      this.uploading = "in progress";
      return new Promise(resolve => {
        resolve(this.submitFormToServer());
      })
        .then(response => {
          if (
            response === "error" ||
            (response.status && response.status !== 200)
          ) {
            this.sendErrorLog(response);
            this.uploading = "error";
            return "error";
          } else {
            console.log("Ready to images ...");
            let formGuid = localStorage.getItem("formId");
            let apiKey = localStorage.getItem("apiKey");
            let host = window["APIhost"];
            let url = host + "/api/images/imagesync?apiKey=" + apiKey;
            let savedImages = [];
            let imagesToSync = [];
            let imageCount = 0;
            let imageTotal = 0;

            if (this.vuexImages.length > 0 || this.repeaterImages.length > 0) {
              console.log("vuexImages: ", this.vuexImages);
              this.vuexImages.forEach(image => {
                savedImages.push({
                  key: image.id,
                  value: image
                });
              });

              this.repeaterImages.forEach(image => {
                savedImages.push({
                  key: image.id,
                  value: image
                });
              });

              imageCount = 1;
              imageTotal = savedImages.length;

              savedImages.forEach(savedImage => {
                imagesToSync.push(() => {
                  return new Promise(resolve => {
                    let dataView = new DataView(savedImage.value.data);
                    let registrationId = savedImage.value.registrationId;
                    let repeaterRegistrationId = savedImage.value.repeaterRegistrationId;
                    let blob = new Blob([dataView], {
                      type: savedImage.value.type
                    });
                    let obj = {
                      data: blob,
                      filename: savedImage.value.fileName,
                      filepath: savedImage.value.filePath
                    };

                    console.log("savedImage: ", savedImage);

                    let fd = new FormData();
                    fd.append("imageId", savedImage.value.id);
                    fd.append("formGuid", formGuid);
                    fd.append("filename", obj.filename);
                    fd.append("data", blob, obj.filename);
                    fd.append("filepath", obj.filepath);
                    fd.append("registrationId", registrationId);
                    fd.append("repeaterRegistrationId", repeaterRegistrationId);

                    let xhr = new XMLHttpRequest();
                    xhr.open("POST", url);
                    xhr.onreadystatechange = () => {
                      if (
                        xhr.readyState === XMLHttpRequest.DONE &&
                        xhr.status === 200
                      ) {
                        imageCount++;
                        resolve();
                      }
                    };
                    xhr.send(fd);
                  });
                });
              });

              clearQueue(imagesToSync).then(() => {
                console.log("done syncing images");
              });
            }
            console.log("imageCount, imageTotal", imageCount, imageTotal);
            return true;
          }
        })
        .then(response => {
          setTimeout(() => {
            if (
              response === "error" ||
              (response.status && response.status !== 200)
            ) {
              this.uploading = "error";
              return false;
            } else {
              this.uploading = "done";
              return true;
            }
          }, 1500);
        });
    }
  },
  created() {
    this.uploadRegistration();
  }
};
</script>
